import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react'
import type { Role } from './nav'

type RoleCtx = { role: Role; setRole: (r: Role) => void }
const Ctx = createContext<RoleCtx | null>(null)
const KEY = 'expas-role'

/**
 * Active role. Seeded from the demo override / persisted choice; the real Entra
 * token claim feeds this in the auth step. Drives which nav + actions are shown.
 */
export function RoleProvider({ children }: { children: ReactNode }) {
  const [role, setRoleState] = useState<Role>(
    () => (localStorage.getItem(KEY) as Role | null) ?? 'underwriter',
  )
  const setRole = useCallback((r: Role) => {
    localStorage.setItem(KEY, r)
    setRoleState(r)
  }, [])
  const value = useMemo(() => ({ role, setRole }), [role, setRole])
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useRole() {
  const ctx = useContext(Ctx)
  if (!ctx) throw new Error('useRole must be used within RoleProvider')
  return ctx
}
